module.exports = __webpack_public_path__ + "static/media/icon_sunday.cf84be33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_sunday.svg
// module id = 779
// module chunks = 1